export const fieldNames = {
  EMAIL_ADDRESS: 'emailAddress',
  PHONE_NUMBER: 'telephoneNumber',
};

export const getFieldsConfig = () => ({
  [fieldNames.EMAIL_ADDRESS]: {
    defaultLabel: 'Email Address',
    defaultPlaceholder: 'Email Address',
    name: fieldNames.EMAIL_ADDRESS,
    autoComplete: 'email',
    format: '',
    type: 'email',
  },
  [fieldNames.PHONE_NUMBER]: {
    defaultLabel: 'Phone Number',
    defaultPlaceholder: 'Phone Number',
    name: fieldNames.PHONE_NUMBER,
    format: () => {},
    parse: () => {},
    maxLength: 12,
  },
});
